import React from "react";
import { useNavigate } from "react-router-dom";
const Footer = () => {
  const navi = useNavigate();
  return (
    <div>
      <footer className="my-5 pt-5 text-muted text-center text-small">
        <p className="mb-1">&copy; 2022–2122 Harrypoterble co Ltd.</p>
        <ul className="list-inline">
          <li className="list-inline-item">
            <p>Privacy</p>
          </li>
          <li className="list-inline-item">
            <p>Terms</p>
          </li>
          <li className="list-inline-item p-cursor">
            <p onClick={() => {
                    navi("/contact");
                  }}>
            Support</p>
          </li>
        </ul>
      </footer>
    </div>
  );
};

export default Footer;
